export default [
    {
        Link: 'https://github.com/Swizec/serverlesshandbook.dev',
        Title: 'GitHub',
    },
    {
        Link: 'https://serverlesshandbook.dev/',
        Title: 'Serverless Handbook',
    },
] 